import { render, staticRenderFns } from "./ResolutionCenterNewTicket.vue?vue&type=template&id=a3382a42&scoped=true&"
import script from "./ResolutionCenterNewTicket.vue?vue&type=script&lang=js&"
export * from "./ResolutionCenterNewTicket.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionCenterNewTicket.vue?vue&type=style&index=0&id=a3382a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3382a42",
  null
  
)

export default component.exports